import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';

import { Copper, Prepreg, Material } from '../../../models';
import { copperOz2inch, inchToString } from '../../../lib/unitConversions';
import { calcFillRatio } from '../../../lib/copper';
import { calcPressedThickness } from '../../../lib/prepreg';

export const CopperSummary = (props) => {
  const { layer, layers, prepreg, lengthUnit } = props;
  const { weight, plating, isOuter, copperFill } = layer;
  const thickness = copperOz2inch(weight, plating, isOuter);
  const fillRatio = calcFillRatio(thickness, copperFill);
  const isPrepregUp = prepreg && prepreg.index < layer.index;
  const pressedThickness = prepreg ?
    isPrepregUp
      ? calcPressedThickness(prepreg, prepreg.index, layers, null, layer) 
      : calcPressedThickness(prepreg, prepreg.index, layers, layer, null)
  : 0;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container justify="flex-end">
          <pre>
            Copper thickness:
            {' '}
            {inchToString(thickness, lengthUnit)}
            <br /> 
            {process.env.NODE_ENV === 'development' ? ( 
              <span>
                Fill Ratio:
                {' '}
                {inchToString(fillRatio, lengthUnit)}
                <br />
                {prepreg ? (
                  <div>
                    Prepreg Glass Thickness:
                    {' '}
                    {prepreg && inchToString(prepreg.glassThickness, lengthUnit)}
                  </div>
                ) : null}
              </span>
            ) : null}
            {pressedThickness
              ? `Prepreg Pressed Thickness: ${
                inchToString(pressedThickness, lengthUnit)
              }`
              : ''}
            <br />
          </pre>
        </Grid>
      </Grid>
    </Grid>
  );
}

CopperSummary.propTypes = {
  layer:      PropTypes.instanceOf(Copper).isRequired,
  layers:     PropTypes.arrayOf(PropTypes.instanceOf(Material)).isRequired,
  prepreg:    PropTypes.instanceOf(Prepreg),
  lengthUnit: PropTypes.string.isRequired,
};

CopperSummary.defaultProps = {
  prepreg: undefined 
}

export default CopperSummary;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/CopperSummary.jsx